module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-8-7becf7f3475ce303210b36ed8fc4b1eb.svg";